export const tileTypes = {
  DEFAULT: "DEFAULT",
  DEFAULT_WITH_ICON: "DEFAULT_WITH_ICON",
  SMALL: "SMALL",
};
